import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import TopUpBalance from './TopUpBalance';
import { OFFER_DEDUCT } from '../../config';
import {convertToRupiah} from '../../utils';

class NoteOffer extends Component{
  render(){
    const offerDeduct = convertToRupiah((parseFloat(OFFER_DEDUCT)));
    return(
      <div className="sneaker-info-container note">
        {/* <p>Please note</p>
        <p>1. If the seller accepts your OFFER, you will be charged accordingly and we will return your OFFER deposits upon successful payment.</p>
        <p>2. Your account will be penalised should you fail to complete the transaction within the time period.</p>
        <p>3. You may change your OFFER at anytime before the seller accepts it.</p>
        <p>4. The amount above is NOT including shipping. For shipping details, visit our <span><Link to="/helps/faq">FAQ</Link></span> </p> */}
        <p>1. You must have the full offer amount in available in your Kick Credit balance.</p>
        <TopUpBalance />
        {/* <Link to="/user_dashboard/profile-settings"><p style={{textDecoration: 'underline', color: '#4990e2', cursor: 'pointer'}}>TOP UP BALANCE</p></Link> */}
        <p>2. Your kick credit will be deducted IDR. {offerDeduct},- which will be held as a DEPOSIT. This will be returned to you if your offer is accepted and you complete payment.</p>
        <p>3. If your offer is accepted and you do NOT complete payment, the DEPOSIT will not be returned and is claimed by our company. </p>
        <p>4. Only make offers with genuine intent to purchase. Failure to pay will flag your offer as a "hit and run" on our systems and your account may be suspended.</p>
        <p>5. You cannot make an offer that is higher than the listed price.</p>
        <p>6. Offer expires in 30 days. Maintain your offer list on your profile dashboard. </p>

        {/* <SmallNotes style={{marginTop:'3rem'}}>By clicking Checkout, user has read and agreed to Kick Avenue Terms and Conditions</SmallNotes> */}
      </div>
    )
  }
}

export default NoteOffer;

const SmallNotes = styled.p`
    font-style: italic;
    font-size: 11px;
    color: #bbb;
    direction:rtl;
    text-align:justify;
`
